import { api } from "@/frontend/services/api";
import type {
  CreateMatchTeamRequestDTO,
  UpdateMatchTeamRequestDTO,
  MatchTeamResponseDTO,
  MatchTeamsPaginatedResponseDTO,
  MatchTeamQueryDTO,
  ApiResponse,
} from "@/shared/dto";

const BASE_URL = "/match-teams/private";

export const matchTeamService = {
  getPaginate: (params?: MatchTeamQueryDTO) =>
    api.getWithParams<ApiResponse<MatchTeamsPaginatedResponseDTO>>(BASE_URL, params),
  getById: (id?: string) =>
    api.get<ApiResponse<MatchTeamResponseDTO>>(`${BASE_URL}/${id}`),
  create: (data: CreateMatchTeamRequestDTO) =>
    api.post<ApiResponse<MatchTeamResponseDTO>>(BASE_URL, data),
  update: (id: string, data: UpdateMatchTeamRequestDTO) =>
    api.put<ApiResponse<MatchTeamResponseDTO>>(`${BASE_URL}/${id}`, data),
  delete: (id: string) =>
    api.delete<ApiResponse<void>>(`${BASE_URL}/${id}`),
};
